// extracted by mini-css-extract-plugin
module.exports = {"body":"AutoLogoutPopup_body__3mfcE","logoutButton":"AutoLogoutPopup_logoutButton__31Xcb","em":"AutoLogoutPopup_em__15Ljt"};